import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class VimeoEmbed extends Component {
  state = {
    open: false
  };

  getSrc = (autoplay) => {
    const { videoId, hash } = this.props;
    const params = [];
    if (hash) params.push('h=' + hash);
    params.push('badge=0', 'autopause=0');
    if (autoplay) params.push('autoplay=1');
    return 'https://player.vimeo.com/video/' + videoId + '?' + params.join('&');
  };

  openLightbox = () => {
    this.setState({ open: true });
    document.body.style.overflow = 'hidden';
  };

  closeLightbox = () => {
    this.setState({ open: false });
    document.body.style.overflow = '';
  };

  handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.state.open) {
      this.closeLightbox();
    }
  };

  componentDidMount () {
    if (this.props.popover) {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = '';
  }

  renderPlayer (autoplay) {
    return (
      <div className='vimeo-embed'>
        <iframe
          src={this.getSrc(autoplay)}
          title={this.props.title}
          frameBorder='0'
          allow='autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
          referrerPolicy='strict-origin-when-cross-origin'
          allowFullScreen
        />
      </div>
    );
  }

  renderLightbox () {
    if (!this.state.open) return null;

    return ReactDOM.createPortal(
      <div className='vimeo-lightbox' role='dialog' aria-modal='true'
        aria-label={this.props.title}>
        <div className='vimeo-lightbox-backdrop' onClick={this.closeLightbox} />
        <div className='vimeo-lightbox-dialog'>
          <button type='button' className='vimeo-lightbox-close' onClick={this.closeLightbox}
            aria-label='Close video'>&times;</button>
          {this.renderPlayer(true)}
        </div>
      </div>,
      document.body
    );
  }

  render () {
    if (!this.props.popover) {
      return this.renderPlayer(false);
    }

    const className = this.props.className ? this.props.className : 'medicareVideo';

    return (
      <span className={className + ' vimeo-popover'}>
        <button
          type='button'
          className='vimeo-popover-trigger'
          onClick={this.openLightbox}
          aria-label={'Play video: ' + this.props.title}
        >
          <img src={this.props.thumbnail} alt='' width='400'
            height='225' />
        </button>
        {this.renderLightbox()}
      </span>
    );
  }
}

export default VimeoEmbed;
